<template>
  <div>
    <v-card>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-select
              v-model="component"
              :loading="loadingSpecialty"
              :label="$t('common.GroupBy')"
              :items="componentOptions"
              item-text="label"
              item-value="id"
              return-object
            />
            <v-select
              v-model="selectedColumns"
              :loading="loadingSpecialty"
              label="Colunas"
              :items="columnOptions"
              item-text="label"
              item-value="id"
              return-object
            />
            <LogDateFilter :logs="logs" @filterMap="dateFilterMap = $event"/>
          </v-flex>
          <v-flex xs12 md4>
            <LogFilter :logs="logs" @filterMap="filterMap = $event" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <StatisticsTable
      id="stats"
      :logs="filteredLogs"
      :component="component"
      :columns="selectedColumns"
    />
  </div>
</template>

<script>
import StatisticsTable from './StatisticsTable'
import specialtyFetcher from '../../mixins/specialtyFetcher'
import { mapActions, mapGetters } from 'vuex'
import { Component } from '../../models/Specialty'
import LogDateFilter from '@/components/LogDateFilter'
import LogFilter from '@/components/LogFilter'
import statistics from '@/statistics'
import { LogMapper } from '@/statistics/mappers/base'

export default {
  components: {
    StatisticsTable,
    LogDateFilter,
    LogFilter
  },
  mixins: [specialtyFetcher],
  data() {
    return {
      component: null,
      allColumns: { id: 'all', label: this.$t('common.All'), options: [] },
      loadingSpecialty: true,
      selectedFilterId: null,
      selectedColumns: { id: 'all', label: this.$t('common.All'), options: [] },
      filterValues: [],
      filterMap: null,
      dateFilterMap: null
    }
  },
  methods: {
    ...mapActions(['getLogs']),
  },
  computed: {
    ...mapGetters(['user']),
    specialty() {
      return this.$store.getters.specialty
    },
    filterOptions() {
      return this.mapper.getOptions(this.selectedFilter, this.logs)
    },
    mapper() {
      return statistics[this.specialty] || LogMapper
    },
    columnOptions() {
      return [
        this.allColumns,
        ...this.mapper.columns.map((col) =>
          Component.query()
            .where((c) => c.id === col)
            .withAllRecursive()
            .first()
        ),
      ]
    },
    logs() {
      return this.$store.getters.logs
    },
    filteredLogs() {
      const filteredLogs = []
      for (let i = 0; i < this.logs.length; i++) {
        if( 
          (!this.dateFilterMap || this.dateFilterMap[i]) &&
          (!this.filterMap || this.filterMap[i])
        ) {
          filteredLogs.push(this.logs[i])
        }
      }
      return filteredLogs
    },
    componentOptions() {
      let components = Component.query()
        .where('statistics', true)
        .withAllRecursive()
        .get()
      return components
    },
    selectedFilter() {
      return this.componentOptions.find((cf) => cf.id === this.selectedFilterId)
    },
  },
  created() {
    this.fetchSpecialtyIfEmpty().finally(() => (this.loadingSpecialty = false))
    this.getLogs()
  },
}
</script>
